<h2 mat-dialog-title>{{ editing ? 'Edit ' + data.method!.name : 'Add payout method' }}</h2>

<mat-dialog-content class="fields">
  @if (!editing) {
  <mat-form-field appearance="outline" subscriptSizing="dynamic">
    <mat-label>Kind</mat-label>
    <mat-select [(ngModel)]="kind">
      <mat-option value="Wallet">Crypto wallet</mat-option>
      <mat-option value="Bank">Bank card / Shaba</mat-option>
    </mat-select>
  </mat-form-field>
  }

  <mat-form-field appearance="outline" subscriptSizing="dynamic">
    <mat-label>Name</mat-label>
    <input matInput [(ngModel)]="name" maxlength="100" placeholder="e.g. USDT (TRC-20)">
  </mat-form-field>

  @if (kind === 'Wallet') {
  <mat-form-field appearance="outline" subscriptSizing="dynamic">
    <mat-label>Address pattern (regex, optional)</mat-label>
    <input matInput [(ngModel)]="addressPattern" maxlength="500" dir="ltr" placeholder="e.g. ^T[1-9A-HJ-NP-Za-km-z]{33}$">
  </mat-form-field>

  <mat-form-field appearance="outline" subscriptSizing="dynamic">
    <mat-label>Sending</mat-label>
    <mat-select [(ngModel)]="onchainNetwork">
      <mat-option value="">An admin pays by hand</mat-option>
      <mat-option value="BSC">Sent from the hot wallet (USDT on BSC / BEP-20)</mat-option>
    </mat-select>
  </mat-form-field>
  @if (onchainNetwork) {
  <p class="hint">
    New requests through this method can be sent by the app itself (Payments › Setup › Crypto payouts).
    Only for USDT on BNB Smart Chain: the address pattern should be ^0x[0-9a-fA-F]{{ '{' }}40{{ '}' }}$.
  </p>
  }

  <h3 class="section">Exchange rate</h3>
  <p class="hint">Requests are in Toman; the supplier is paid in coin at this Toman rate, fixed when they submit.</p>

  <div class="row">
    <mat-form-field appearance="outline" subscriptSizing="dynamic">
      <mat-label>Rate source</mat-label>
      <mat-select [(ngModel)]="rateSource">
        @for (s of data.rateSources; track s) {
        <mat-option [value]="s">{{ s === 'Manual' ? 'Manual (I type the rate)' : s }}</mat-option>
        }
      </mat-select>
    </mat-form-field>
    <mat-form-field appearance="outline" subscriptSizing="dynamic">
      <mat-label>Currency code{{ isManual ? ' (optional)' : '' }}</mat-label>
      <input matInput [(ngModel)]="rateSymbol" maxlength="20" dir="ltr" placeholder="e.g. usdt, trx">
    </mat-form-field>
  </div>

  <div class="row">
    <mat-form-field appearance="outline" subscriptSizing="dynamic">
      <mat-label>Manual rate (Toman per coin){{ isManual ? '' : ' — fallback' }}</mat-label>
      <input matInput [(ngModel)]="manualRate" inputmode="decimal" dir="ltr" placeholder="e.g. 268500">
    </mat-form-field>
    <mat-form-field appearance="outline" subscriptSizing="dynamic">
      <mat-label>Decimals of coin amount</mat-label>
      <input matInput type="number" min="0" max="8" [(ngModel)]="amountDecimals">
    </mat-form-field>
  </div>
  @if (!isManual) {
  <p class="hint">
    The currency code is checked with {{ rateSource }} when you save. If {{ rateSource }} goes down, the last
    rate is used for up to 30 minutes; after that, switch the source to Manual.
  </p>
  }
  }

  @if (error) { <p class="error"><mat-icon>error</mat-icon> {{ error }}</p> }
</mat-dialog-content>

<mat-dialog-actions align="end">
  <button mat-button type="button" [disabled]="saving" (click)="cancel()">Cancel</button>
  <button mat-flat-button color="primary" type="button" [disabled]="saving" (click)="save()">
    @if (saving) { <mat-spinner diameter="18"></mat-spinner> } Save
  </button>
</mat-dialog-actions>
